module.exports = __webpack_public_path__ + "img/mistakesText5.aa0c5205.png";